import * as React from 'react';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import * as Web from "./Web";
import { ErrorAlert, IErrorInfo } from './ErrorAlert';

export enum WorkshopStatus {
   Created = 0,
   PreRegistration = 1,
   Registration = 2,
   Testing = 3,
   Closed = 4,
   Invisible =5
};

export enum PaymentType {
   Free = 0,
   CreditCard = 1
};

export interface Workshop {
   id?: number,
   guid?: string,
   name?: string,
   startDate?: string,
   endDate?: string,
   location?: string,
   email?: string,
   status?: WorkshopStatus,
   fee?: string,
   paymentType?: PaymentType,
   maxUsers?: number
};

export const WorkshopPage = () => {
   const [workshops, setWorkshops] = React.useState<Workshop[]>([]);
   const [start, setStart] = React.useState(0);
   const [count, setCount] = React.useState(10);
   const [doFetch, setDoFetch] = React.useState(false);
   const [error, setError] = React.useState<IErrorInfo | null>(null);

   React.useEffect(() => {
      let controller = new AbortController();
      if (doFetch) {
         fetch();
      }
      async function fetch() {
         const response = await Web.httpGet(`api/workshop?start=${start}&count=${count}`, controller);
         if (response?.errorCode) {
            setWorkshops([]);
            setError(response);
         }
         else {
            setWorkshops(response?.result);
            setError(null);
         }

         console.log(response?.result);
         setDoFetch(false);
      }
      return function cleanup() {
         controller.abort();
      };
   }, [start, count, doFetch]);
    return (
      <Container sx={{ mt: 10 }}>
         {(error) ? <ErrorAlert {...error} /> : undefined}
         <Box sx={{ mb: 14 }} >
            <Typography variant="h4">{"Workshops"}</Typography>
            <Typography variant="body1">{"Past and future IOP Workshops."}</Typography>
         </Box>

         <Box sx={{ mb: 14, flexGrow: 1, display: 'flex' }}>
            <TextField
               label={"Start"}
               variant="outlined"
               slotProps={{ htmlInput: { inputMode: 'numeric', pattern: '[0-9]*' }, }}
               value={start}
               onChange={(e) => setStart(Number(e.target.value))}
               sx={{ mr: 10 }}
            />
            <TextField
               label="Count"
               variant="outlined"
               slotProps={{htmlInput: {inputMode: 'numeric', pattern: '[0-9]*' }, }}
               value={count}
               onChange={(e) => setCount(Number(e.target.value))}
               sx={{ mr: 10 }}
            />
            <Button
               variant="contained"
               onClick={() => setDoFetch(true)}
               disabled={doFetch}
            >
               Update
            </Button>
         </Box>

         <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell><Typography variant="bold">Name</Typography></TableCell>
                        <TableCell><Typography variant="bold">Start Date</Typography></TableCell>
                        <TableCell><Typography variant="bold">Status</Typography></TableCell>
                        <TableCell><Typography variant="bold">Location</Typography></TableCell>
                    </TableRow>
               </TableHead>
               <TableBody>
                  {workshops.map(item =>
                     <TableRow key={item.id}>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{Web.formatDateString(item.startDate)}</TableCell>
                        <TableCell>{WorkshopStatus[item.status ?? 0]}</TableCell>
                        <TableCell>{item.location}</TableCell>
                     </TableRow>
                  )}
               </TableBody>
            </Table>
         </TableContainer>
      </Container>
   );
}

export default WorkshopPage;